import React, { useRef, useState } from "react";
import styles from "./VehiclesContainer.module.scss";
import { Button, Input, Modal, Select } from "antd";
import phoneIcon from "../../Assets/my BIds/Frame.svg";
import threeDotsIcon from "../../Assets/blackDots.svg";
import Paginations from "Components/UI/Pagination/Pagination";
import { Option } from "antd/es/mentions";
import doneIcon from "../../Assets/done.svg";
import disableIccon from "../../Assets/disableIcon.svg";

export const VehiclesContainer = () => {
  const [isAddVehicleOpen, setIsAddVehicleOpen] = useState(false);
  const [isVehicleInfoOpen, setIsVehicleInfoOpen] = useState(false);
  const [isChangeLocationOpen, setIsChangeLocationOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleRadioChange = (option:any) => setSelectedOption(option);

  const handleAddVehicleModal = () => {
    setIsAddVehicleOpen(true);
  };

  const handleVehicleInfoModal = () => {
    setIsVehicleInfoOpen(true);
  };

  const handleChangeLocationModal = () => {
    setIsChangeLocationOpen(true);
  };

  const generalInfoRef = useRef(null);
  const vehicleSizesRef = useRef(null);
  const vehicleDetailsRef = useRef(null);
  const licenseInfoRef = useRef(null);
  const otherInfoRef = useRef(null);

  const scrollToSection = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div className={styles.vehicles}>
      <div className={styles.header}>
        <h1>Vehicles</h1>
        <Button onClick={handleAddVehicleModal}>+ Add vehicle</Button>
      </div>
      <table>
        <thead>
          <tr>
            <th className={styles.unit}>
              <input type="checkbox" name="" id="" />
              Unit id
            </th>
            <th className={styles.vehicle}>VEHICLE</th>
            <th className={styles.location} >
              LOCATION
            </th>
            <th className={styles.note}>NOTE</th>
            <th className={styles.status}>STATUS</th>
            <th className={styles.responsible}>RESPONSIBLE</th>
            <th className={styles.action}>ACTION</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.unit}>
              <input type="checkbox" name="" id="" />
              <p>
                <p className={styles.name}>Alisher tohirov</p>W004, 3000 lbs
              </p>
            </td>
            <td>Cargo Van <p className={styles.size}>155x6071 in</p></td>
            <td>
              <span className={styles.location} onClick={handleChangeLocationModal}>4163 N Bloomington Ave arlington...</span> <span className={styles.date}> 02:36am 10/26/2023,</span> by <span className={styles.driver}>driver</span> 
            </td>
            <td>
              <Input type="text" />
            </td>
            <td className={styles.status}>
              <p className={styles.green}>Available</p>
            </td>
            <td>Wiser Inc</td>
            <td className={styles.action}>
              <img src={phoneIcon} alt="phone-icon" />
              <img
                src={threeDotsIcon}
                alt="threeDots"
                onClick={handleVehicleInfoModal}
              />
            </td>
          </tr>

          <tr>
            <td className={styles.unit}>
              <input type="checkbox" name="" id="" />
              <p>
                <p className={styles.name}>Alisher tohirov</p>W004, 3000 lbs
              </p>
            </td>
            <td>Cargo Van <p className={styles.size}>155x6071 in</p></td>
            <td>
              <span className={styles.location} onClick={handleChangeLocationModal}>4163 N Bloomington Ave arlington...</span> <span className={styles.date}> 02:36am 10/26/2023,</span> by <span className={styles.driver}>driver</span> 
            </td>
            <td>
              <Input type="text" />
            </td>
            <td className={styles.status}>
              <p className={styles.green}>Available</p>
            </td>
            <td>Wiser Inc</td>
            <td className={styles.action}>
              <img src={phoneIcon} alt="phone-icon" />
              <img src={threeDotsIcon} alt="threeDots" />
            </td>
          </tr>

          <tr>
            <td className={styles.unit}>
              <input type="checkbox" name="" id="" />
              <p>
                <p className={styles.name}>Alisher tohirov</p>W004, 3000 lbs
              </p>
            </td>
            <td>Cargo Van <p className={styles.size}>155x6071 in</p></td>
            <td>
              <span className={styles.location} onClick={handleChangeLocationModal}>4163 N Bloomington Ave arlington...</span> <span className={styles.date}> 02:36am 10/26/2023,</span> by <span className={styles.driver}>driver</span> 
            </td>
            <td>
              <Input type="text" />
            </td>
            <td className={styles.status}>
              <p className={styles.red}> Not available</p>
            </td>
            <td>Wiser Inc</td>
            <td className={styles.action}>
              <img src={phoneIcon} alt="phone-icon" />
              <img src={threeDotsIcon} alt="threeDots" />
            </td>
          </tr>

          <tr>
            <td className={styles.unit}>
              <input type="checkbox" name="" id="" />
              <p>
                <p className={styles.name}>Alisher tohirov</p>W004, 3000 lbs
              </p>
            </td>
            <td>Cargo Van <p className={styles.size}>155x6071 in</p></td>
            <td>
              <span className={styles.location} onClick={handleChangeLocationModal}>4163 N Bloomington Ave arlington...</span> <span className={styles.date}> 02:36am 10/26/2023,</span> by <span className={styles.driver}>driver</span> 
            </td>
            <td>
              <Input type="text" />
            </td>
            <td className={styles.status}>
              <p className={styles.red}> Not available</p>
            </td>
            <td>Wiser Inc</td>
            <td className={styles.action}>
              <img src={phoneIcon} alt="phone-icon" />
              <img src={threeDotsIcon} alt="threeDots" />
            </td>
          </tr>
        </tbody>
      </table>

      <Paginations link="#" className={styles.pagination} />

      {/* Add Vehicle Modal */}
      <Modal
        onCancel={() => setIsAddVehicleOpen(false)}
        title={<h2 className={styles.addVehicleTitle}>Add Vehicle</h2>}
        visible={isAddVehicleOpen}
        width={800}
        footer={null}
      >
        <div className={styles.addVehicleModal}>
          <section className={styles.menu}>
            <ul>
              <li onClick={() => scrollToSection(generalInfoRef)}>
                General Info
              </li>
              <li onClick={() => scrollToSection(vehicleSizesRef)}>
                Vehicle Sizes
              </li>
              <li onClick={() => scrollToSection(vehicleDetailsRef)}>
                Vehicle Details
              </li>
              <li onClick={() => scrollToSection(licenseInfoRef)}>
                License Info
              </li>
              <li onClick={() => scrollToSection(otherInfoRef)}>Other Info</li>
            </ul>
          </section>
          <form className={styles.form}>
            <h3 ref={generalInfoRef}>General info</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">Unit ID</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">Transport type</label>
                <Select
                  defaultValue="Select type"
                  className={styles.vehicleTypeSelect}
                >
                  <Option>Car</Option>
                  <Option>Truck</Option>
                  <Option>Box truck</Option>
                  <Option>SUV</Option>
                </Select>
              </div>
              <div>
                <label htmlFor="">Vehicle model</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">Vehicle year</label>
                <Input />
              </div>
            </div>

            <h3 ref={vehicleSizesRef}>Vehicle Sizes</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">Width (in)</label>
                <Input type="number" />
              </div>
              <div>
                <label htmlFor="">Height (in)</label>
                <Input type="number" />
              </div>
              <div>
                <label htmlFor="">Lenght (in)</label>
                <Input type="number" />
              </div>
              <div>
                <label htmlFor="">Payload (lbs)</label>
                <Input type="number" />
              </div>
            </div>

            <h3 ref={vehicleDetailsRef}>Vehicle Details</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">VIN</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">Height (in)</label>
                <Input />
              </div>
            </div>

            <h3 ref={licenseInfoRef}>License Info</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">License plate</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">License state</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">License expiry date</label>
                <Input />
              </div>
              <div>
                <label htmlFor="">License state</label>
                <Input />
              </div>
            </div>

            <h3 ref={otherInfoRef}>Other Info</h3>
            <div>
              <label htmlFor="">Dispatcher</label>
              <Input />
            </div>
            <div>
              <label htmlFor="">Vehicle owner</label>
              <Input type="email" placeholder="name@example.com" />
            </div>
            <div>
              <label htmlFor="">Drivers</label>
              <Input type="email" placeholder="name@example.com" />
            </div>
            <div>
              <label htmlFor="">Active driver</label>
              <Input type="email" placeholder="name@example.com" />
            </div>
            <Button className={styles.saveBtn}>Save changes</Button>
          </form>
        </div>
      </Modal>

      {/* Vehicle Info Modal */}
      <Modal
        onCancel={() => setIsVehicleInfoOpen(false)}
        title={<h2 className={styles.addVehicleTitle}>Vehicle Info</h2>}
        visible={isVehicleInfoOpen}
        width={800}
        footer={null}
      >
        <div className={styles.addVehicleModal}>
          <section className={styles.menu}>
            <ul>
              <li onClick={() => scrollToSection(generalInfoRef)}>
                General Info
              </li>
              <li onClick={() => scrollToSection(vehicleSizesRef)}>
                Vehicle Sizes
              </li>
              <li onClick={() => scrollToSection(vehicleDetailsRef)}>
                Vehicle Details
              </li>
              <li onClick={() => scrollToSection(licenseInfoRef)}>
                License Info
              </li>
              <li onClick={() => scrollToSection(otherInfoRef)}>Other Info</li>
            </ul>
          </section>
          <form className={styles.form}>
            <h3 ref={generalInfoRef}>General info</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">Unit ID</label>
                <Input value="W003" />
              </div>
              <div>
                <label htmlFor="">Transport type</label>
                <Select
                  defaultValue="LARGE STRAIGHT"
                  className={styles.vehicleTypeSelect}
                >
                  <Option>Car</Option>
                  <Option>Truck</Option>
                  <Option>Box truck</Option>
                  <Option>SUV</Option>
                </Select>
              </div>
              <div>
                <label htmlFor="">Vehicle model</label>
                <Input value="FSF" />
              </div>
              <div>
                <label htmlFor="">Vehicle year</label>
                <Input value="2023" />
              </div>
            </div>

            <h3 ref={vehicleSizesRef}>Vehicle Sizes</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">Width (in)</label>
                <Input type="number" value="12" />
              </div>
              <div>
                <label htmlFor="">Height (in)</label>
                <Input type="number" value="13" />
              </div>
              <div>
                <label htmlFor="">Lenght (in)</label>
                <Input type="number" value="260" />
              </div>
              <div>
                <label htmlFor="">Payload (lbs)</label>
                <Input type="number" value="8000" />
              </div>
            </div>

            <h3 ref={vehicleDetailsRef}>Vehicle Details</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">VIN</label>
                <Input value="1 FDFDFDFDFDG32" />
              </div>
              <div>
                <label htmlFor="">Height (in)</label>
                <Input value="12" />
              </div>
            </div>

            <h3 ref={licenseInfoRef}>License Info</h3>
            <div className={styles.mainInfo}>
              <div>
                <label htmlFor="">License plate</label>
                <Input value="P 122323" />
              </div>
              <div>
                <label htmlFor="">License state</label>
                <Input value="NY" />
              </div>
              <div>
                <label htmlFor="">License expiry date</label>
                <Input value="2024-03-31" />
              </div>
              <div>
                <label htmlFor="">License state</label>
                <Input value="2024-03-31" />
              </div>
            </div>

            <h3 ref={otherInfoRef}>Other Info</h3>
            <div>
              <label htmlFor="">Dispatcher</label>
              <Input />
            </div>
            <div>
              <label htmlFor="">Vehicle owner</label>
              <Input
                value="John sdsdsd, john@wiserinc.us"
                type="email"
                placeholder="name@example.com"
              />
            </div>
            <div>
              <label htmlFor="">Drivers</label>
              <Input
                value="MURUDJON KHOJIEV, dsdsdsd@gmail.com"
                type="email"
                placeholder="name@example.com"
              />
            </div>
            <div>
              <label htmlFor="">Active driver</label>
              <Input
                value="MURUDJON KHOJIEV, dsdsdsd@gmail.coms"
                type="email"
                placeholder="name@example.com"
              />
            </div>
          </form>
        </div>
      </Modal>

      {/* Change Location Modal */}
      <Modal
        onCancel={() => setIsChangeLocationOpen(false)}
        title={<h2 className={styles.addVehicleTitle}>Change location</h2>}
        visible={isChangeLocationOpen}
        width={700}
        footer={null}
        className={styles.changeLocationModal}
      >
        <section    style={{ backgroundColor: (selectedOption === 'current' || selectedOption === 'both')  ? '#8dc6f633' : 'transparent' }}>
          <h4>Current</h4>
          <div>
            <label htmlFor="">Location</label>
            <Input value="157 Major Grahams Rd, Fort Chiswell, VA 24360" />
            <div>
              <img src={doneIcon} alt="done-icon" />
              <p>Enabled for searching loads</p>
            </div>
          </div>
        </section>
        <section    style={{ backgroundColor: (selectedOption === 'planned' || selectedOption === 'both') ? '#8dc6f633' : 'transparent' }}>
          <h4>Planned</h4>
          <div>
            <label htmlFor="">Location</label>
            <Input
              className={styles.plannedLocation}
              value="157 Major Grahams Rd, Fort Chiswell, VA 24360"
            />
            <Input type="date" />
            <div className={styles.plannedAlert}>
              <img src={disableIccon} alt="disable-icon" />
              <p>Disabled for searching loads</p>
            </div>
          </div>
        </section>
        <p className={styles.selectLocationTitle}>
          Select locations to show on Loadboard and Capacity Search
        </p>
        <div className={styles.radioBtns}>
          <div className={styles.radioBtn}>
            <input type="radio" id="current" name="radioGroup" 
            checked={selectedOption === "current"}
            onChange={() => handleRadioChange("current")}
            />
            <label htmlFor="current">Current</label>
          </div>
          <div className={styles.radioBtn}>
            <input type="radio" id="planned" name="radioGroup" 
            checked={selectedOption === "planned"}
            onChange={() => handleRadioChange("planned")}
            />
            <label htmlFor="planned">Planned</label>
          </div>
          <div className={styles.radioBtn}>
            <input type="radio" id="both" name="radioGroup" 
            checked={selectedOption === "both"}
            onChange={() => handleRadioChange("both")}
            />
            <label htmlFor="both">Both</label>
          </div>
        </div>
        <Button>Save</Button>
      </Modal>
    </div>
  );
};
